type Props = {
  width?: number;
  height?: number;
  viewBox?: string;
};

const CreditIcon = ({
  width = 18,
  height = 18,
  viewBox = "0 0 18 18",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <circle
        cx="9"
        cy="9.5"
        r="8.625"
        fill="url(#paint0_linear_975_24802)"
        stroke="#0AC4B2"
        strokeWidth="0.75"
      />
      <path
        d="M10.8101 8.04028L10.8638 8.35156H11.1797H12.7148H13.1446L13.0864 7.92579C12.9454 6.89398 12.4729 6.06118 11.7638 5.48893C11.0575 4.91896 10.1387 4.625 9.12891 4.625C7.92676 4.625 6.85406 5.066 6.08394 5.89636C5.31523 6.7252 4.875 7.91214 4.875 9.35938C4.875 10.7997 5.30873 11.9865 6.07436 12.8171C6.84183 13.6498 7.91504 14.0938 9.12891 14.0938C11.3284 14.0938 12.8247 12.6585 13.086 10.8425L13.1477 10.4141H12.7148H11.1797H10.8723L10.812 10.7155C10.6535 11.5077 10.0123 11.9727 9.15234 11.9727C8.56211 11.9727 8.07994 11.7539 7.73855 11.3433C7.39117 10.9254 7.16016 10.2724 7.16016 9.35938C7.16016 8.45803 7.3883 7.80416 7.73525 7.38295C8.07599 6.96928 8.55816 6.74609 9.15234 6.74609C10.0307 6.74609 10.6701 7.2283 10.8101 8.04028Z"
        fill="white"
        stroke="#0AC4B2"
        strokeWidth="0.75"
      />
      <defs>
        <linearGradient
          id="paint0_linear_975_24802"
          x1="9"
          y1="0.5"
          x2="9"
          y2="18.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3FD8C9" />
          <stop offset="1" stopColor="#A3EFE6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CreditIcon;
